import React from 'react';
import { useTranslation } from 'react-i18next';
import FavouriteIcon from '@wix/da-shared-react/pkg/Icons/Favourite';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';

import s from './FavouritesLabel.scss';

export interface Props {
  className?: string;
}

const FavouritesLabel = (props: Props) => {
  const { t } = useTranslation();
  return (
    <span className={s['root']}>
      <FavouriteIcon
        className={s['icon']}
        disableDefaultColors={true}
        size={IconSize.TINY}
      />{' '}
      {t('common.favourites_plural')}
    </span>
  );
};

export default FavouritesLabel;
